import axios from "axios";
import UserService from "./UserService";

const createAxiosInstance = (baseURL, headers = {}) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      ...headers,
    },
  });

  // Add request interceptor to attach tokens
  instance.interceptors.request.use(
    async (config) => {
      if (UserService.isLoggedIn()) {
        // Refresh token if it's close to expiration
        await UserService.updateToken(() => {
          config.headers.Authorization = `Bearer ${UserService.getToken()}`;
        });
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Flag to ensure logout is triggered only once on 401 errors
  let isLoggingOut = false;

  // Add response interceptor for error handling
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && !isLoggingOut) {
        isLoggingOut = true;
        UserService.doLogout();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Create specific instances
export const hostingDeploymentsAxiosInstance = createAxiosInstance(
  process.env.REACT_APP_HOSTING_BASE_URL,
  {
    "Content-Type": "application/vnd.api+json",
    "Accept": "application/vnd.api+json",
  }
);

export const userManagementAxiosInstance = createAxiosInstance(
  process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
);

export const organizationAxiosInstance = createAxiosInstance(
  process.env.REACT_APP_BACKEND_BASE_URL
);

export const settingsAxiosInstance = createAxiosInstance(
  process.env.REACT_APP_SETTINGS_BASE_URL
);

export default createAxiosInstance;
